import React from 'react'
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  ColumnSeries,
  Category,
  Legend,
  Tooltip,
  DataLabel,
  AxisModel,
  LineSeries,
} from '@syncfusion/ej2-react-charts'
import { Browser } from '@syncfusion/ej2-base'
import { ChartSeriesData } from '@dataTypes/dashboard.types'
type ColumnLineChartsProps = {
  title: string
  data: ChartSeriesData[]
  seriesNames: string[]
  colors: string[]
  chartHeight?: string
  lineData: ChartSeriesData[]
  lineSeriesNames: string[]
  lineColor: string[]
  yAxisSettings?: AxisModel
  xAxisSettings?: AxisModel
}

function ColumnLineCharts({
  title,
  data,
  seriesNames,
  colors,
  yAxisSettings,
  xAxisSettings,
  chartHeight,
  lineData,
  lineColor,
  lineSeriesNames,
}: ColumnLineChartsProps): React.ReactElement {
  const defaultYAxisSettings: AxisModel = {
    title: '',
    majorGridLines: { width: 1 },
    majorTickLines: { width: 0 },
    lineStyle: { width: 0 },
    maximum: 65,
    minimum: 35,
    interval: 5,
  }

  const defaultXAxistSettings: AxisModel = {
    labelIntersectAction: Browser.isDevice ? 'None' : 'Trim',
    labelRotation: Browser.isDevice ? -45 : 0,
    valueType: 'Category',
    interval: 1,
    majorGridLines: { width: 1 },
    majorTickLines: { width: 0 },
  }

  return (
    <div className="dashboard-control-pane" key={title}>
      {/* <style>{SAMPLE_CSS}</style> */}
      <div className="dashboard-control-section">
        <ChartComponent
          id={title}
          style={{ textAlign: 'center' }}
          legendSettings={{
            visible: true,
            position: 'Top',
            alignment: 'Near',
            height: '50',
          }}
          primaryXAxis={xAxisSettings ?? defaultXAxistSettings}
          primaryYAxis={yAxisSettings ?? defaultYAxisSettings}
          tooltip={{
            enable: true,
            header: '<b>${point.tooltip}</b>',
            shared: true,
          }}
          width={'100%'}
          height={chartHeight ?? '300'}
        >
          <Inject
            services={[
              ColumnSeries,
              Category,
              Legend,
              Tooltip,
              DataLabel,
              LineSeries,
            ]}
          />
          <SeriesCollectionDirective>
            {lineSeriesNames.map((name, index) => (
              <SeriesDirective
                key={name}
                dataSource={lineData}
                tooltipMappingName={'xValue'}
                xName="xValue"
                yName={name}
                name={name}
                type="Line"
                marker={{ visible: false }}
                width={5}
                fill={lineColor[index]}
              />
            ))}
            {seriesNames.map((name, index) => (
              <SeriesDirective
                key={name}
                dataSource={data}
                tooltipMappingName={'xValue'}
                xName="xValue"
                yName={name}
                name={name}
                type="Column"
                legendShape="Circle"
                fill={colors[index]}
              />
            ))}
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
    </div>
  )
}

export default ColumnLineCharts
